module.exports = __webpack_public_path__ + "img/logo-BNB.090b8f20.svg";